import React from "react";

import { Switch, Route, RouteComponentProps } from "react-router";

import PrivateRoute from "../../routers/PrivateRoute";

import ConnectionLinkPage from "./pages/ConnectionLinkPage";
import ForgottenPasswordPage from "./pages/ForgottenPasswordPage";
import LoginPage from "./pages/LoginPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SAMLPage from "./pages/SAMLPage";

type LoginScreenProps = RouteComponentProps;

const LoginScreen: React.FC<LoginScreenProps> = () => {
  return (
    <Switch>
      <Route exact path="/login">
        <LoginPage />
      </Route>
      <Route exact path="/connection-link">
        <ConnectionLinkPage />
      </Route>
      <Route exact path="/forgotten-password">
        <ForgottenPasswordPage />
      </Route>
      <Route exact path="/saml-sso">
        <SAMLPage />
      </Route>
      <PrivateRoute
        exact
        path="/reset-password"
        withLayout={false}
        component={ResetPasswordPage}
      />
    </Switch>
  );
};

export default React.memo(LoginScreen);
